<template>
  <!-- {{ auction.live_player_id }} - {{ pools_data.length }} =
  {{ live_player_bids.length }} - {{ all_players.length }}, PoolID:
  {{ live_player_pool_id }} -->

  <div class="row" v-if="auction.live_player_id && !is_player_sold">
    <div class="col d-flex justify-content-center mt-2">
      <span class="text-muted">Next Bid : </span>
      <span class="fw-bold text-primary">
        {{ formatToIndianCurrency(bid_amount) }}
      </span>
    </div>
  </div>
  <div class="row">
    <div class="col" v-if="msg.length">
      <ul class="list-group">
        <li class="list-group-item bg-warning bidbtn" v-for="m in msg" :key="m">
          {{ m }}
        </li>
      </ul>
    </div>
  </div>
  <div
    class="row mt-2 d-flex align-items-center"
    v-if="auction.live_player_id && !is_player_sold"
  >
    <div class="col-1" v-for="(t, index) in sorted_teams" :key="t">
      <button
        class="btn btn-primary btn-sm bidbtn mt-2 hoverinfo"
        @click="submitBid(t.id)"
      >
        <LogoSmall :path="t.icon"></LogoSmall>

        <span class="fw-bold">{{ index + 1 }} - {{ t.name }}</span>
        <br />
        {{ formatToIndianCurrency(t.wallet) }} <br />
        <span class="text-warning">
          {{ formatToIndianCurrency(maxBidLimitForThisTeam(t.id)) }}</span
        >
      </button>
    </div>
  </div>
  <div class="row" v-else>
    <div class="col fw-bold text-primary" v-if="!auction.live_player_id">
      No player selected
    </div>
    <div class="col fw-bold text-danger" v-else>Player sold!!</div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, computed, watchEffect } from "vue";
import { useStore } from "@/store/index";
import LogoSmall from "../../bidder/logos/LogoSmall.vue";
const store = useStore();
const bidding_teams = ref([]); //live listner to teams - to get their wallet amounts
const auction = ref({}); //live listner to auction
//const sold_players = ref([]); //live listner to sold players - used for pool conditions checking
const all_players = ref([]); //listner to all players fetched at load - to get live_players pool
const pools_data = ref([]); // fetched to get pools conditions.
const live_player_bids = ref([]); //listner to bids of live player
const live_player_pool_id = computed(() => {
  var pool_id = "";
  if (auction.value.live_player_id) {
    all_players.value.forEach((p) => {
      if (p.id == auction.value.live_player_id) {
        pool_id = p.pool_id;
      }
    });
  }
  return pool_id;
});
const is_player_sold = computed(() => {
  var sold = false;
  sold_players.value.forEach((p) => {
    if (p.id == auction.value.live_player_id) {
      sold = true;
    }
  });
  return sold;
});
const bid_amount = computed(() => {
  var amount = 0;
  if (sorted_bids.value.length) {
    amount = sorted_bids.value[0].amount + auction.value.bid_increment;
  } else {
    //amount = auction.value.bid_increment;
    amount = auction.value.base_price;
  }
  return amount;
});
const msg = ref([]);
const submitting = ref("");
const submitBid = async (team_id) => {
  isPoolQuotaComplete(team_id);
  //isBalanceAvailable(team_id);
  checkMaxBidLimit(team_id);
  isTeamAllotted(auction.value.live_player_id); // check if team has already been allotted
  checkIfBiddingOpen();
  if (!msg.value.length) {
    //console.log("submit bid here");
    const bidObj = {
      auction_id: store.live_auction,
      player_id: auction.value.live_player_id,
      team_id: team_id,
      amount: bid_amount.value,
    };
    const { data, error } = await supabase
      .from("bids")
      .insert([bidObj])
      .select();
    if (!error) {
      submitting.value = "Submitting bid...";
      setTimeout(() => {
        submitting.value = submitting.value + "done!";
      }, 1000);
    }
  }
  setTimeout(() => {
    msg.value = [];
    submitting.value = "";
  }, 2000);
};
const isTeamAllotted = (player_id) => {
  all_players.value.forEach((p) => {
    if (p.id == player_id && p.team_id) {
      msg.value.push("Team allotted. Player already sold!");
    }
  });
};
const checkIfBiddingOpen = () => {
  if (!auction.value.bidding_open) {
    msg.value.push("Bidding not opened");
  }
};
const isPoolQuotaComplete = (team_id) => {
  var purchased_by_this_team = 0;
  var allowed_quota = 0;
  pools_data.value.forEach((p) => {
    if (p.id == live_player_pool_id.value) {
      allowed_quota = p.count;
    }
  });
  sold_players.value.forEach((sp) => {
    if (sp.team_id == team_id && sp.pool_id == live_player_pool_id.value)
      purchased_by_this_team++;
  });
  if (purchased_by_this_team >= allowed_quota) {
    msg.value.push("Pool quota complete");
  }
};
const checkMaxBidLimit = (team_id) => {
  var team_wallet = 0;
  var purchase_count = 0;
  bidding_teams.value.forEach((t) => {
    if (t.id == team_id) {
      team_wallet = t.wallet;
    }
  });
  sold_players.value.forEach((p) => {
    if (p.team_id == team_id) {
      purchase_count++;
    }
  });
  const team_size = auction.value.to_purchase;
  const max_bid =
    team_wallet - (team_size - purchase_count - 1) * auction.value.base_price;
  if (bid_amount.value > max_bid) {
    msg.value.push("Insufficient balance. Bid cannot be more than: " + max_bid);
  }
  return max_bid;
};
const maxBidLimitForThisTeam = (team_id) => {
  var team_wallet = 0;
  var purchase_count = 0;
  bidding_teams.value.forEach((t) => {
    if (t.id == team_id) {
      team_wallet = t.wallet;
    }
  });
  sold_players.value.forEach((p) => {
    if (p.team_id == team_id) {
      purchase_count++;
    }
  });
  const team_size = auction.value.to_purchase;
  const max_bid =
    team_wallet - (team_size - purchase_count - 1) * auction.value.base_price;

  return max_bid;
};
const isBalanceAvailable = (team_id) => {
  var min_blocked_amount = 0;
  var wallet_balance = 0;
  var purchase_count = 0;
  bidding_teams.value.forEach((t) => {
    if (t.id == team_id) {
      wallet_balance = t.wallet;
    }
  });
  sold_players.value.forEach((p) => {
    if (p.team_id == team_id) {
      purchase_count++;
    }
  });
  min_blocked_amount =
    auction.value.bid_increment * (auction.value.team_size - purchase_count);
  if (bid_amount.value >= min_blocked_amount) {
    msg.value.push(
      "Insufficient balance. Bid cannot be more than: " + min_blocked_amount
    );
  }
};
const minBlockedAmount = (team_id) => {
  var min_blocked_amount = 0;
  var purchase_count = 0;
  sold_players.value.forEach((p) => {
    if (p.team_id == team_id) {
      purchase_count++;
    }
  });
  min_blocked_amount =
    auction.value.bid_increment * (auction.value.team_size - purchase_count);
  return min_blocked_amount;
};
const sorted_bids = computed(() => {
  var arr = [];
  live_player_bids.value.forEach((b) => {
    arr.push(b);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => b.amount - a.amount);
  return sorted_arr;
});

onMounted(() => {
  setTimeout(() => {
    fetchTeams();
    fetchAuction();
    fetchPools();
    fetchAllPlayers();
  }, 1000);
});
const fetchAllPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_players.value = players;
  setupPlayersListner();
};
const setupPlayersListner = () => {
  const channels = supabase
    .channel("all-players-assist-custom-update-channel")
    .on(
      "postgres_changes",
      { event: "UPDATE", schema: "public", table: "players" },
      (payload) => {
        //console.log("Change received!", payload);
        if (payload.new.auction_id == store.live_auction) {
          const updatedArray = all_players.value.map((obj) =>
            obj.id === payload.new.id ? { ...obj, ...payload.new } : obj
          );
          all_players.value = updatedArray;
        }
      }
    )
    .subscribe();
};
const sold_players = computed(() => {
  var arr = [];
  all_players.value.forEach((p) => {
    if (p.team_id && p.sale_price) {
      //checking for p.sale_price because core team players not to be included
      arr.push(p);
    }
  });
  return arr;
});
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  pools_data.value = pools;
};
const fetchTeams = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("auction_id", store.live_auction);
  bidding_teams.value = teams;
  setupTeamsListner();
};
const setupTeamsListner = () => {
  const channels = supabase
    .channel("assist-teams-custom-update-channel")
    .on(
      "postgres_changes",
      { event: "UPDATE", schema: "public", table: "teams" },
      (payload) => {
        // console.log("Change received!", payload);
        if (payload.new.auction_id == store.live_auction) {
          const updatedArray = bidding_teams.value.map((obj) =>
            obj.id === payload.new.id ? { ...obj, ...payload.new } : obj
          );
          bidding_teams.value = updatedArray;
        }
      }
    )
    .subscribe();
};
const sorted_teams = computed(() => {
  var arr = [];
  bidding_teams.value.forEach((t) => {
    arr.push(t);
  });
  var sorted_arr = [];
  sorted_arr = arr.sort((a, b) => a.name.localeCompare(b.name));
  return sorted_arr;
});
const fetchAuction = async () => {
  auction.value = {};
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
  setupAuctionListner();
};
const setupAuctionListner = () => {
  const channels = supabase
    .channel("assist-auction-custom-filter-channel")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "auctions",
        filter: `id=eq.${store.live_auction}`,
      },
      (payload) => {
        //console.log("Change received!", payload);
        auction.value = payload.new;
      }
    )
    .subscribe();
};
const fetchLivePlayerBids = async () => {
  live_player_bids.value = [];
  let { data: bids, error } = await supabase
    .from("bids")
    .select("*")
    .eq("player_id", auction.value.live_player_id);
  live_player_bids.value = bids;
  setupLivePlayerBidsListner();
};
const setupLivePlayerBidsListner = () => {
  const channels = supabase
    .channel("live-player-bids-custom-all-channel")
    .on(
      "postgres_changes",
      { event: "*", schema: "public", table: "bids" },
      (payload) => {
        if (payload.eventType == "INSERT") {
          if (
            payload.new.auction_id == store.live_auction &&
            payload.new.player_id == auction.value.live_player_id
          ) {
            live_player_bids.value.push(payload.new);
          }
        }
        if (payload.eventType == "DELETE") {
          //console.log(payload.new); //payload.old.id
          live_player_bids.value = live_player_bids.value.filter(
            (item) => item.id !== payload.old.id
          );
        }
        if (payload.eventType == "UPDATE") {
          const index = live_player_bids.value.findIndex(
            (item) => item.id === payload.old.id
          );
          if (index != -1) {
            live_player_bids.value.splice(index, 1);
            live_player_bids.value.push(payload.new);
          }
        }
        //console.log("Change received!", payload);
      }
    )
    .subscribe();
};
watchEffect(() => {
  if (auction.value.live_player_id) {
    fetchLivePlayerBids();
  }
});
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
</script>
<style scoped>
.bidbtn {
  padding: 2px;
  font-size: 12px;
}
.tinytxt {
  font-size: 10px;
}
.hoverinfo:hover {
  background: red;
}
</style>
